export default __webpack_public_path__ + "static/media/Ballroll_00264.966bfd09.png";